// App.jsx
import React, { useState, useEffect } from 'react'
import AppLayout from './components/AppLayout'
import AppLayoutEl from './components/AppLayout_El'
import TestLayout from './components/TestLayout'
import AIHiringAgent from './components/AIHiringAgent'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { fetchQueries } from './utils/api'
import './components/DiscoverySequenceSettings.css'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#64748b'
    },
    secondary: {
      main: '#4f46e5'
    },
    background: {
      default: '#1f2937',
      paper: '#374151'
    },
    text: {
      primary: '#e5e7eb',
      secondary: '#9ca3af'
    }
  }
})

/**
 * Process queries data to create macros by categories
 * @param {any} data - The raw queries data
 * @param {boolean} isNewTree - Whether to use the new tree structure
 * @param {boolean} isTesting - Whether in testing mode
 * @returns {any} - Processed macros by categories
 */
const postFetchQueries = (
  data,
  isNewTree = false,
  isTesting = false
) => {
  let macros_by_id = JSON.parse(JSON.stringify(data));
  const keys_all = Object.keys(macros_by_id);
  const connections_dups = [];
  keys_all.forEach((mid) => {
    const macro = macros_by_id[mid];
    let cats = [];
    if (macro.macro_taxonomy && macro.macro_taxonomy[0]) {
      const idx = macro.categories.indexOf('Connection');
      if (idx >= 0) {
        macro.categories.splice(idx, 1);
      }
      // if macro_taxonomy is ATS Source or ATS By Stage delete it from macros_by_id
      if (
        isTesting &&
        (macro.macro_taxonomy[0].indexOf('ATS Source') >= 0 ||
          macro.macro_taxonomy[0].indexOf('ATS By Stage') >= 0 ||
          macro.macro_taxonomy[0].indexOf('ATS Rejected') >= 0)
      ) {
        macros_by_id[mid].macro_taxonomy = ['Unknown'];
        macros_by_id[mid].ui_categories = ['Unknown'];
        // delete macros_by_id[mid];
        // return;
      }
    }
    const conn = macro.categories.indexOf('Connection') >= 0;
    if (conn && connections_dups.indexOf(macro.name) === -1) {
      if (!macro.meta.is_private) {
        // Only private connection macros are considred.
        return;
      }
      macro.ui_categories = [];
      macros_by_id['connections_' + mid] = {
        ref: 'connections_' + mid,
        ver: macro.ver,
        categories: macro.categories,
        ui_categories: ['My Company', 'Connections'],
        name: macro.name,
        description: macro.description
      };
      connections_dups.push(macro.name);
    }

    const cust = macro.categories.indexOf('Custom List') >= 0;
    if (cust) {
      if (!macro.meta.is_private) {
        // Only private connection macros are considred.
        return;
      }
      macro.ui_categories = [];
      if (macro.defs && macro.defs.length > 0) {
        // this is the case where its a compound macro of custom lists - most likely must have's of two custom lists.
        // the category of this new compound macro will have "Custom List" but the macro_taxonomy won't be set. Just set it to
        // one of the component macro
        // macro.macro_taxonomy = [];
        // macro.macro_taxonomy.push(macros_by_id[macro.defs[0].macro_id].macro_taxonomy[0]);
        macros_by_id[mid] = {
          ref: mid,
          ver: macro.ver,
          categories: macro.categories,
          ui_categories: macro.ui_categories,
          keyword_cxt: macro.keyword_cxt,
          name: macro.name,
          query_keyword_op: macro.query_keyword_op,
          meta: macro.meta,
          defs: macro.defs,
          description: macro.description,
          is_org_public: macro.is_org_public
        };
        return;
      }
      macro.ui_categories = [];
      if (!macro.macro_taxonomy || macro.macro_taxonomy.length == 0) {
        return;
      }
      macro.macro_taxonomy[0] = macro.macro_taxonomy[0]?.trim();
      macros_by_id[mid] = {
        ref: mid,
        ver: macro.ver,
        categories: macro.categories,
        ui_categories: macro.macro_taxonomy[0]?.split(';'),
        name: macro.name,
        meta: macro.meta,
        description: macro.description,
        macro_taxonomy: macro.macro_taxonomy,
        query_keyword_op: macro.query_keyword_op,
        keyword_cxt: macro.keyword_cxt,
        defs: macro.defs,
        is_org_public: macro.is_org_public
      };

      if (macro.macro_taxonomy && macro.macro_taxonomy[0]) {
        let tax = '';


        if (macro.macro_taxonomy[0].indexOf('Company Lists') >= 0) {
          if (macro.macro_taxonomy[0].indexOf('Past or Current Company') >= 0) {
            tax = 'Company;Past or Current Company;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Past Company') >= 0) {
            tax = 'Company;Past Company;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Recent Company') >= 0) {
            tax = 'Company;Recent Company;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Current Company') >= 0) {
            tax = 'Company;Current Company;Custom Lists';
          }
        } else if (macro.macro_taxonomy[0].indexOf('Degree Lists') >= 0) {
          tax = 'Education;Degree;Custom Lists';
        }   else if (macro.macro_taxonomy[0].indexOf('Graduation Year') >= 0) {
          tax = 'Graduation Year';
        } else if (macro.macro_taxonomy[0].indexOf('Role Lists') >= 0) {
          if (macro.macro_taxonomy[0].indexOf('Past or Current Role') >= 0) {
            tax = 'Roles;Past or Current Role;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Past Role') >= 0) {
            tax = 'Roles;Past Role;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Recent Role') >= 0) {
            tax = 'Roles;Recent Role;Custom Lists';
          } else if (macro.macro_taxonomy[0].indexOf('Current Role') >= 0) {
            tax = 'Roles;Current Role;Custom Lists';
          }
        } else if (macro.macro_taxonomy[0].indexOf('School Lists') >= 0) {
          tax = 'Education;School;Custom Lists';
        } else if (macro.macro_taxonomy[0].indexOf('Major Lists') >= 0) {
          tax = 'Education;Major;Custom Lists';
        }
        macros_by_id['cust_' + mid] = {
          ref: mid,
          ver: macro.ver,
          categories: macro.categories,
          ui_categories: tax.split(';'),
          name: macro.name,
          meta: macro.meta,
          description: macro.description,
          keyword_cxt: macro.keyword_cxt,
          macro_taxonomy: macro.macro_taxonomy,
          query_keyword_op: macro.query_keyword_op,
          defs: macro.defs,
          is_org_public: macro.is_org_public
        };
        keys_all.push('cust_' + mid);
      }
      return;
    }

    // "My Data;My Lists;Company Lists;Past or Current Company;Past or Current Company Lists;"
    macros_by_id[mid].ui_categories = macros_by_id[mid]?.ui_categories
      ? macros_by_id[mid]?.ui_categories
      : [];
    if (macros_by_id[mid].ui_categories.indexOf('Career Timeline') >= 0) {
      macros_by_id[mid].ui_categories = ['Career Timeline'];
      return;
    }
    if (mid.indexOf('cust_') >= 0) {
      macros_by_id[mid].ui_categories = macro.macro_taxonomy[0]?.split(';');
      return;
    }

    if (macro.macro_taxonomy && macro.macro_taxonomy[0]) {
      if (macro.macro_taxonomy[0].indexOf('My Company') >= 0) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Findem Magic;',
          ''
        );
        cats = macro.macro_taxonomy[0].split(';');
      } else if (macro.macro_taxonomy[0].indexOf('Diversity') >= 0) {
        macros_by_id[mid].ui_categories = [];
      } else if (
        macro.macro_taxonomy[0].indexOf('Recent') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Role') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Recent',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Role;',
          'Roles;'
        );
        cats = macro.macro_taxonomy[0].split(';');
        cats.splice(1, 0, 'Recent Role');
      } else if (
        macro.macro_taxonomy[0].indexOf('Past or Current') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Role') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Past or Current',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Role;',
          'Roles;'
        );
        cats = macro.macro_taxonomy[0].split(';');
        cats.splice(1, 0, 'Past or Current Role');
      } else if (
        macro.macro_taxonomy[0].indexOf('Past') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Role') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(';Past', '');
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Role;',
          'Roles;'
        );
        cats = macro.macro_taxonomy[0].split(';');
        cats.splice(1, 0, 'Past Role');
      } else if (
        macro.macro_taxonomy[0].indexOf('Current') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Role') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Current',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Role;',
          'Roles;'
        );
        cats = macro.macro_taxonomy[0].split(';');
        cats.splice(1, 0, 'Current Role');
      } else if (macro.macro_taxonomy[0].indexOf('Role Experience') >= 0) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Work Experience;',
          'Role;'
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Role;',
          'Roles;'
        );
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', '');
        cats = macro.macro_taxonomy[0].split(';');
        // cats.splice(1, 0, "Role");
      } else if (
        macro.macro_taxonomy[0].indexOf('Past or Current') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Company') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Past or Current',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Company;',
          'Past or Current Company;'
        );
        if (macro.macro_taxonomy[0].indexOf('Company Lists') >= 0) {
          macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
            'Company Lists',
            'Past or Current Company Lists'
          );
        }

        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', 'Roles;');
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', '');
        cats = macro.macro_taxonomy[0].split(';');
        if (macro.macro_taxonomy[0].indexOf('Company Lists') < 0) {
          cats[cats.length - 1] = 'Past or Current ' + cats[cats.length - 1];
        }
      } else if (
        macro.macro_taxonomy[0].indexOf('Current') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Company') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Current',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Company;',
          'Current Company;'
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Company Lists',
          'Current Company Lists'
        );
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', 'Roles;');
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', '');
        cats = macro.macro_taxonomy[0].split(';');
        if (macro.macro_taxonomy[0].indexOf('Company Lists') < 0 && macro.macro_taxonomy[0].indexOf('Funding') < 0) {
          cats[cats.length - 1] = 'Current ' + cats[cats.length - 1];
        }
      } else if (
        macro.macro_taxonomy[0].indexOf('Recent') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Company') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          ';Recent',
          ''
        );
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Company;',
          'Recent Company;'
        );
        if (macro.macro_taxonomy[0].indexOf('Company Lists') >= 0) {
          macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
            'Company Lists',
            'Recent Company Lists'
          );
        }

        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', 'Roles;');
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', '');
        cats = macro.macro_taxonomy[0].split(';');
        if (macro.macro_taxonomy[0].indexOf('Company Lists') < 0) {
          cats[cats.length - 1] = 'Recent ' + cats[cats.length - 1];
        }
      } else if (
        macro.macro_taxonomy[0].indexOf('Past') >= 0 &&
        macro.macro_taxonomy[0].indexOf('Company') >= 0
      ) {
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(';Past', '');
        macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
          'Company;',
          'Past Company;'
        );
        if (macro.macro_taxonomy[0].indexOf('Company Lists') >= 0) {
          macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace(
            'Company Lists',
            'Past Company Lists'
          );
        }

        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', 'Roles;');
        // macro.macro_taxonomy[0] = macro.macro_taxonomy[0].replace('Role;', '');
        cats = macro.macro_taxonomy[0].split(';');
        if (macro.macro_taxonomy[0].indexOf('Company Lists') < 0) {
          cats[cats.length - 1] = 'Past ' + cats[cats.length - 1];
        }
      } else if (macro.macro_taxonomy[0].indexOf('Role;') >= 0) {
        macros_by_id[mid].ui_categories = [];
        return;
      } else {
        cats = macro.macro_taxonomy[0].split(';');
      }
      cats = cats.filter((val) => val);
      macros_by_id[mid].ui_categories = cats;
      // } else if (!macro.auto_gen_cxt &&
      //   macro.categories?.includes("v2") &&
      //   !macro.categories?.includes("Compound") &&
      //   macro.meta.is_private &&
      //   macro.ui_categories?.length > 0) {
      //   let ui_cats = macro.ui_categories;
      //   macro.ui_categories = ['Private Queries'].push(...ui_cats);
    } else if (!macro.auto_gen_cxt) {
      macros_by_id[mid].ui_categories = [];
    }

    // bad hack. Ideal way is to change the taxanomy. But since we have two sidebars in place now.
    // it is difficult
    // TODO: Remove this once we have correct taxonomy in place.

    if (isNewTree) {
      if (macro.macro_taxonomy && macro.macro_taxonomy[0] && !cust) {
        if (
          (macro.macro_taxonomy &&
            macro.macro_taxonomy[0].includes(
              'Work Experience;Current Company'
            )) ||
          (macro.macro_taxonomy &&
            macro.macro_taxonomy[0].includes('Work Experience;Past Company')) ||
          (macro.macro_taxonomy &&
            macro.macro_taxonomy[0].includes(
              'Work Experience;Recent Company'
            )) ||
          (macro.macro_taxonomy &&
            macro.macro_taxonomy[0].includes(
              'Work Experience;Past or Current Company'
            ))
        ) {
          const isCompanySize = macro.macro_taxonomy[0].includes('Size');
          const uiCategories = macro.ui_categories;
          /*
            we are moving company size as a separate category.
            so we are removing it from the ui_categories
          */
          if (isCompanySize) {
            macro.ui_categories = ['Company Size', ...uiCategories.slice(-1)];
          } else {
            uiCategories[0] = 'Company';
            macro.ui_categories = uiCategories;
          }


          if(macro.macro_taxonomy[0].includes('Current Company;Stage') ||
            macro.macro_taxonomy[0].includes('Past Company;Stage') ||
            macro.macro_taxonomy[0].includes('Recent Company;Stage') ||
            macro.macro_taxonomy[0].includes('Past or Current Company Company;Stage') ||
            macro.macro_taxonomy[0].includes('Current Company;Business Model') ||
            macro.macro_taxonomy[0].includes('Past Company;Business Model') ||
            macro.macro_taxonomy[0].includes('Recent Company;Business Model') ||
            macro.macro_taxonomy[0].includes('Past or Current Company Company;Business Model') ||
            macro.macro_taxonomy[0].includes('Current Company;Growth Rate') ||
            macro.macro_taxonomy[0].includes('Past Company;Growth Rate') ||
            macro.macro_taxonomy[0].includes('Recent Company;Growth Rate') ||
            macro.macro_taxonomy[0].includes('Past or Current Company Company;Growth Rate'))
            {
              macro.ui_categories[0] = 'Company Attributes';
              macro.ui_categories = uiCategories;
            }

          macros_by_id[mid] = macro;
        }

        if (
          macro.macro_taxonomy &&
          macro.macro_taxonomy[0].includes('Roles;Role Experience')
        ) {
          const uiCategories = macro.ui_categories;
          uiCategories[0] = 'Work Experience';
          macro.ui_categories = uiCategories;
          macros_by_id[mid] = macro;
        }
        if (
          macro.macro_taxonomy &&
          macro.macro_taxonomy[0].includes('Education;Graduation Year')
        ) {
          macro.macro_taxonomy[0] = 'Graduation Year';
          macro.ui_categories = ['Graduation Year'];
        }
        if (
          macro.macro_taxonomy &&
          macro.macro_taxonomy[0].includes('Findem Magic;Certification')
        ) {
          macro.macro_taxonomy[0] = 'Certifications';
          macro.ui_categories = ['Certifications'];
        }
      }
    }
  });
  macros_by_id = changeCustomListTaxonomy(macros_by_id);
  macros_by_id = addSpecialFindemQueries(macros_by_id);
  // macros_by_id = data;

  return macros_by_id;
};

/**
 * Helper function to change custom list taxonomy
 * @param {any} macros_by_id - The macros by ID
 * @returns {any} - Updated macros by ID
 */
const changeCustomListTaxonomy = (macros_by_id) => {
  // This is a placeholder implementation - you may need to adjust based on actual requirements
  return macros_by_id;
};

/**
 * Helper function to add special Findem queries
 * @param {any} macros_by_id - The macros by ID
 * @returns {any} - Updated macros by ID with special queries
 */
const addSpecialFindemQueries = (macros_by_id) => {
  // This is a placeholder implementation - you may need to adjust based on actual requirements
  return macros_by_id;
};
/**
 * Fetch user information from the Findem API
 * @returns {Promise<Object>} User information
 */
const fetchUserInfo = async () => {
  try {
    const response = await fetch('https://matches.findem.ai/api/user_info', {
      method: 'GET',
      credentials: 'include',
      redirect: 'follow', // Ensure the browser automatically follows redirects
    });

    // console.log('Initial Response:', response);

    if (response.redirected) {
      // console.log('Redirect detected to:', response.url);

      // Check if the redirect URL is the login page
      if (response.url.includes('/auth/login')) {
        window.location.href = 'https://matches.findem.ai/auth/login'; // Manually redirect
        throw new Error('User is not authenticated. Redirected to login page.');
      }
    }

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching user_info:', error.message);
  }
};


const USE_NEW_BACKEND = false // Set to `false` to use the old backend
// https://matches.findem.ai/api/user_info
function App () {
  // Check if we're in test mode (URL has ?test=true)
  const isTestMode = new URLSearchParams(window.location.search).get('test') === 'true'
  
  // Check if we're in AI hiring agent mode (URL has ?hiring=true)
  const isHiringMode = new URLSearchParams(window.location.search).get('hiring') === 'true'
  
  // Get session ID from URL query parameter
  const urlParams = new URLSearchParams(window.location.search)
  const sessionIdFromUrl = urlParams.get('sessionId')
  
  const [user, setUser] = useState(null) // State to store user info
  const [isLoading, setIsLoading] = useState(true); // State to manage loading
  const [queries, setQueries] = useState(null) // State to store user info
  const [macrosByCategories, setMacrosByCategories] = useState(null) // State to store processed macros
  const [initialSessionId, setInitialSessionId] = useState(sessionIdFromUrl) // Store initial session ID from URL

  useEffect(() => {
    // Fetch user info when the component mounts
    const fetchData = async () => {
      try {
        const userInfo = await fetchUserInfo()
        setUser(userInfo)
      } catch (error) {
        console.error('Error fetching user info:', error)
      } finally {
        setIsLoading(false); // Mark loading as complete
      }
    }

    fetchData();
  }, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    // Fetch queries when the component mounts
    const loadQueries = async () => {
      try {
        const q = await fetchQueries();
        setQueries(q);
        
        // Process the queries to create macros by categories
        const processedMacros = postFetchQueries(q, true, false);
        setMacrosByCategories(processedMacros);
      } catch (error) {
        console.error("Error fetching queries:", error.message);
      }
    };
    loadQueries();
  }, []); // Empty dependency array ensures this runs only once

  // If we're in test mode, skip loading user info and queries
  useEffect(() => {
    if (!isTestMode) {
      // Fetch user info when the component mounts
      const fetchData = async () => {
        try {
          const userInfo = await fetchUserInfo()
          setUser(userInfo)
        } catch (error) {
          console.error('Error fetching user info:', error)
        } finally {
          setIsLoading(false); // Mark loading as complete
        }
      }

      fetchData();
    } else {
      // In test mode, we don't need to load user info
      setIsLoading(false);
    }
  }, [isTestMode]); // Add isTestMode to dependency array

  useEffect(() => {
    // Only fetch queries if not in test mode
    if (!isTestMode) {
      // Fetch queries when the component mounts
      const loadQueries = async () => {
        try {
          console.log('🔄 App.jsx: Starting to load queries...');
          const q = await fetchQueries();
          
          if (!q || Object.keys(q).length === 0) {
            console.error('🚨 App.jsx: fetchQueries returned empty or null queries');
            console.log('🔄 App.jsx: Attempting to retry fetchQueries in 2 seconds...');
            
            // Retry after a delay
            setTimeout(async () => {
              try {
                const retryQ = await fetchQueries();
                if (retryQ && Object.keys(retryQ).length > 0) {
                  console.log('✅ App.jsx: Retry successful, queries loaded:', Object.keys(retryQ).length);
                  setQueries(retryQ);
                  
                  // Process the queries to create macros by categories
                  const processedMacros = postFetchQueries(retryQ, true, false);
                  setMacrosByCategories(processedMacros);
                } else {
                  console.error('🚨 App.jsx: Retry also failed, queries still null/empty');
                  // Set an empty object as fallback instead of null
                  setQueries({});
                  setMacrosByCategories({});
                }
              } catch (retryError) {
                console.error('🚨 App.jsx: Retry error:', retryError);
                // Set an empty object as fallback instead of null
                setQueries({});
                setMacrosByCategories({});
              }
            }, 2000);
          } else {
            console.log('✅ App.jsx: Queries loaded successfully, total items:', Object.keys(q).length);
            setQueries(q);
            
            // Process the queries to create macros by categories
            const processedMacros = postFetchQueries(q, true, false);
            setMacrosByCategories(processedMacros);
          }
        } catch (error) {
          console.error("🚨 App.jsx: Error fetching queries:", error.message);
          // Set an empty object as fallback instead of null
          setQueries({});
          setMacrosByCategories({});
        }
      };
      loadQueries();
    }
  }, [isTestMode]); // Add isTestMode to dependency array

  if (isLoading) {
    // Show a loading indicator while user info is being fetched
    return <div>Loading...</div>;
  }

  // If in test mode, render the TestLayout
  if (isTestMode) {
    return <TestLayout />;
  }

  // If in hiring mode, render the AI Hiring Agent
  if (isHiringMode && user) {
    return <AIHiringAgent 
      userInfo={user}
      macrosByCategories={macrosByCategories} 
    />;
  }

  return (
    <ThemeProvider theme={theme}>
      {USE_NEW_BACKEND ? (
        <AppLayoutEl />
      ) : (
        <AppLayout 
          queries={queries} 
          userInfo={user} 
          macrosByCategories={macrosByCategories} 
          initialSessionId={initialSessionId}
        />
      )}
    </ThemeProvider>
  );
}

export default App
